const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_4DUdqPYom',
      userPoolClientId: '4toi6d3kmev2if1a4clmk6joje',
      identityPoolId: 'eu-west-1:44c77856-4851-4b5d-8bb7-4f8d66a74747',
    }
  }
};

export default awsConfig;
